import { Injectable } from '@angular/core';
import { NetworkService } from '@damofire/data-angular-commons';
import { logger, IndexedService, ISSUE_MEDIAS_STORE, readFSFile } from '@damofire/data-commons';
import { FirebaseIssueService } from '../../issue/firebase-issue.service';
import { IdbIssueMedia } from '../../issue/issue.dto';
import { RemoteService } from './remote.service';

@Injectable()
export class IssueMediaRemoteService extends RemoteService<IdbIssueMedia> {
  constructor(
    protected readonly idbService: IndexedService,
    protected readonly networkService: NetworkService,
    private readonly firebaseIssueService: FirebaseIssueService,
  ) {
    super(ISSUE_MEDIAS_STORE, idbService, networkService);
  }

  async add(divisionId: string, data: IdbIssueMedia[]): Promise<void> {
    for (const im of data) {
      const { division, organization, bytesPath, filename, issue, _id: mediaId, annotations } = im;
      const bytes = await readFSFile(bytesPath);
      await this.firebaseIssueService.uploadImage({ division, organization, _id: issue._id }, filename, bytes, mediaId, annotations);
    }
  }

  async delete(divisionId: string, data: IdbIssueMedia[]): Promise<void> {
    for (const im of data) {
      try {
        await this.firebaseIssueService.deleteMedia(im);
      } catch (e) {
        logger.error('Could not perform issue media delete', { error: e, category: 'sync' });
      }
    }
  }

  async update(divisionId: string, data: IdbIssueMedia[]): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for (const { bytes, bytesPath, thumbBytes, thumbBytesPath, ...sanitized } of data) {
      try {
        await this.firebaseIssueService.updateMedia(sanitized);
      } catch (e) {
        logger.error('Could not update issue media.', { category: 'sync' });
      }
    }
  }
}
